/**
 * Code Generators Services Module
 * Exports all code generation services and factory functions
 */
// Service exports
export * from './BarcodeService';
export * from './QrCodeService';
export * from './UtilityCodeService';
export * from './GeneratedCodeService';
// Service imports for factory
import { BarcodeService } from './BarcodeService';
import { QrCodeService } from './QrCodeService';
import { UtilityCodeService } from './UtilityCodeService';
import { GeneratedCodeService } from './GeneratedCodeService';
/**
 * Create all code generator services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all generator service instances
 */
export function createGeneratorsServices(http, config) {
    return {
        barcode: new BarcodeService(http, config),
        qrCode: new QrCodeService(http, config),
        utilityCode: new UtilityCodeService(http, config),
        generatedCode: new GeneratedCodeService(http, config),
    };
}
//# sourceMappingURL=index.js.map